import React, { PureComponent } from 'react';
import { ButtonProps } from 'antd/es/button';
import { Button } from 'antd';

interface ToggleButtonProps extends Omit<ButtonProps, 'onChange'> {
    checked?: boolean;
    defaultChecked?: boolean;
    onChange?: (checked: boolean) => void;
}

interface ToggleButtonState {
    checked: boolean;
}

export class ToggleButton extends PureComponent<ToggleButtonProps, ToggleButtonState> {
    constructor(props) {
        super(props);
        this.state = {
            checked: this.props.checked !== undefined ? this.props.checked : this.props.defaultChecked || false,
        };
    }
    isChecked = () => {
        return this.props.checked !== undefined ? this.props.checked : this.state.checked;
    };
    handleClick = () => {
        const checked = this.isChecked();
        if (this.props.checked !== undefined) {
            // Controlled logic
            this.props.onChange?.(!checked);
        } else {
            // UnControlled logic
            this.setState({ checked: !checked }, () => this.props.onChange?.(!checked));
        }
    };
    render() {
        const { onChange, ...otherProps } = this.props;
        const className = this.isChecked() ? ' toggle-button toggled' : ' toggle-button';
        return <Button className={className} onClick={this.handleClick} {...otherProps} />;
    }
}
